<template>
  <div class="login">
    <login-wrapper greeting="Welcome back, please login to your account.">
      <template v-slot:form>
        <div class="mt-5 mx-auto d-flex login-button">
          <button
            type="button"
            @click="googleLogin"
            class="d-flex mx-auto login-with-google-btn"
          >
            Sign in with Google
          </button>
        </div>
      </template>

      <template v-if="showIncorrectUsernamePassword" v-slot:errors>
        Incorrect username or password
      </template>
      <template v-if="showNotClientUser" v-slot:errors>
        <center>
          {{ $store.state.login.email }} is not a recognised user.<br />
          If you believe it should be, please email
        <a href="mailto:info@covatic.com">info@covatic.com</a>.
        </center>
      </template>
    </login-wrapper>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import LoginWrapper from "../components/Login/LoginWrapper";

export default {
  name: "Login",
  components: { LoginWrapper },
  mixins: [validationMixin],
  validations: {
    username: { required },
    password: { required },
  },
  data: () => ({
    username: process.env.VUE_APP_TESTING_USERNAME || null,
    password: process.env.VUE_APP_TESTING_PASSWORD || null,
    showIncorrectUsernamePassword: false,
    showNotClientUser: false,
  }),
  methods: {
    googleLogin: async function() {
      const resp = await this.$gAuth.signIn();
      const authResponse = resp.getAuthResponse();
      const success = await this.$store.dispatch("logIn", {
        access_token: authResponse.access_token,
        id_token: authResponse.id_token,
      });

      if (success) {
        if (!this.$store.state.login.groups["client-user"]) {
          this.showNotClientUser = true;
          return;
        }
        this.$router.push({ name: "InsightsGDSTrendsOverTime" });
      } else {
        this.showIncorrectUsernamePassword = true;
      }
    },
  },
};
</script>

<style lang="scss">
@import "src/styles/_colors.scss";

.login {
  position: absolute;
  left: 25%;
  top: 25%;
  width: 50%;
  height: 50%;
}

.login-with-google-btn {
  transition: background-color 0.3s, box-shadow 0.3s;

  padding: 12px 16px 12px 42px;
  border: none;
  border-radius: 3px;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25);

  color: #757575;
  font-size: 14px;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;

  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=);
  background-color: white;
  background-repeat: no-repeat;
  background-position: 12px 11px;

  &:hover {
    box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25);
  }

  &:active {
    background-color: #eeeeee;
  }

  &:focus {
    outline: none;
    box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25),
      0 0 0 3px #c8dafc;
  }

  &:disabled {
    filter: grayscale(100%);
    background-color: #ebebeb;
    box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
  }
}
</style>
